import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { Button, ButtonGroup, DropdownButton } from "react-bootstrap";

import { Common, EnableTeacherById } from "../../../helper";
import * as commonApi from "../../../api/commonApi";
import { isEmptyObject } from "../../../util";
import { success } from "../../Shared";

const EnableUserAction = (props) => {
  const { userId, getData, foreName, surName } = props;
  const MySwal = withReactContent(Swal);


  const EnableTeacher = () => {
    MySwal.fire({
      title: Common.EnableUser,
      text: EnableTeacherById(foreName, surName),
      type: "success",
      showCancelButton: true,
      confirmButtonText: Common.EnableUser,
    }).then((result) => {
      if (result.value) {
        confirmEnableTeacher();
      } else {
        MySwal.fire(Common.NotDeleted);
      }
    });
  };

  const confirmEnableTeacher = async () => {
    const enableTeacher = await commonApi.updateUserActiveStatus({
      id: userId,
      active: true
    });
    if (!isEmptyObject(enableTeacher)) {
      success(`${enableTeacher.Items.firstName} ${enableTeacher.Items.lastName} is enabled`);
      getData();
    }
    getData();
  };
  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        id="dropdown-variants-Secondary"
        title={"Action"}
      >
        <Button onClick={EnableTeacher} className="modal-button-danger d-flex justify-content-start">
          <PersonOutlinedIcon />&nbsp;{Common.EnableUser}
        </Button>
      </DropdownButton>
    </>
  )
}

export { EnableUserAction };
